export default __webpack_public_path__ + "static/Knockout-31JuniorMiddlewt-a695549d88946e9f17f7546250c61adf.otf";